import { RootState } from '../store';

export const getIntervalID = (state: RootState) => state.volumeController.intervalID;
export const getIntervalTime = (state: RootState) => state.volumeController.intervalTime;
export const getFadeTimeByName = (state: RootState) => (name: string) =>
  state.volumeController.fadeTime ? state.volumeController.fadeTime[name] : 0;

export const getCount = (state: RootState) => state.volumeController.count;
